/**
 * Validates that given date value is equal or greater than given minAge
 *
 * @param {string} value  - Date in format 'dd.mm.yyyy'
 * @param {number} minAge - Minimum age in years
 *
 * @return {boolean}
 */
const minAge = (value, minAge) => {
  const MIN_AGE = Number(minAge);
  const dateParts = value.split('.');
  const date = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
  const today = new Date();
  let age = today.getFullYear() - date.getFullYear();
  const ageMonths = today.getMonth() - date.getMonth();

  if(ageMonths < 0 || (ageMonths === 0 && today.getDate() < date.getDate())) {
    age--;
  }

  return age >= MIN_AGE;
};

/**
 * Validates that given date value's year is equal or greater than given minYear
 *
 * @param {string} value   - Date in format 'dd.mm.yyyy'
 * @param {number} minYear - Minimum year
 *
 * @return {boolean}
 */
const minYear = (value, minYear) => {
  const MIN_YEAR = Number(minYear);

  const dateParts = value.split('.');//if input type is text, we need to split it to 3 parts
  const date = dateParts.length === 3 ? new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0])) : new Date(value);

  if(!date.getFullYear()) {
    return false; //date is not valid
  }

  return date.getFullYear() >= MIN_YEAR;
};

/**
 * Validates that given number is equal or greated than minValue
 *
 * @param {string} value - Numeric string
 * @param {*} minValue - Minimum value
 *
 * @return {boolean}
 */
const minValue = (value, minValue) => {
  const MIN_VALUE = Number(minValue);
  // check fo commas and replace with decimal
  const parsedValue = parseFloat(value.replace(',', '.'));

  return parsedValue >= MIN_VALUE;
};

/**
 * Validates that selected option amount is equal or less than maxAmount
 *
 * @param {string} value - Numeric string
 * @param {*} maxAmount - Minimum value
 *
 * @return {boolean}
 */
const maxAmount = (value, maxAmount) => {
  const MAX_AMOUNT = Number(maxAmount);
  return value <= MAX_AMOUNT;
};

export {
  minAge,
  minYear,
  minValue,
  maxAmount
};
